import React from 'react';
import { SEV_COLORS } from './constants';

const BADGE_MAP: Record<number, { bg: string; label: string; textColor: string }> = {
  1: { bg: SEV_COLORS.Critical, label: 'CRIT', textColor: '#fff' },
  2: { bg: SEV_COLORS.High,     label: 'HIGH', textColor: '#fff' },
  3: { bg: SEV_COLORS.Medium,   label: 'MED',  textColor: '#000' },
  4: { bg: SEV_COLORS.Low,      label: 'LOW',  textColor: '#fff' },
  5: { bg: SEV_COLORS.Info,     label: 'INFO', textColor: '#fff' },
};

interface SevBadgeProps {
  rating: number | undefined;
}

const SevBadge: React.FC<SevBadgeProps> = ({ rating }) => {
  const c = BADGE_MAP[rating] ?? { bg: '#ccc', label: '?', textColor: '#000' };
  return (
    <span
      style={{
        background: c.bg,
        color: c.textColor,
        padding: '2px 7px',
        borderRadius: 3,
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: '0.5px',
        whiteSpace: 'nowrap',
      }}
    >
      {c.label}
    </span>
  );
};

export default SevBadge;
